import newsReducer from "./newsReducer";

export * from "./newsActions";
export default newsReducer;
